export interface Route {
    route: string;
}
export enum RouteType {
    POINTS_PROMOTION = 'points-promotion',
    POINTS_PROMOTION_TERMS = 'points-promotion/terms',
    VOUCHER = 'prepaid-voucher',
    VOUCHER_APP = 'app-prepaid-voucher',
    TOUR_OPERATOR_PROMO = 'touroperator-promo',
    TRAVELSEARCH_REGION = 'travelsearch/region',
    TRAVELSEARCH_HOTEL = 'travelsearch/hotel',
    TRAVELSEARCH_OFFER = 'travelsearch/offer',
    TRAVELBOOKING_DATA = 'ssl/travelbooking/data',
    TRAVELBOOKING_LOGIN = 'ssl/travelbooking/login',
    GOLDCLUBLANDINGPAGE = 'goldclublandingpage',
    INFO_STEP35 = 'info_step35',
    HIB_HOTEL = 'hotelinfobox/hotel',
    HIB_MEDIA = 'hotelinfobox/media',
    HIB_MAP = 'hotelinfobox/map',
    HIB_RATING = 'hotelinfobox/rating',
    HIB_EQUIPMENT = 'hotelinfobox/equipment',
    SEM_SITELINK = 'sem_sitelink',
    SEM_GENERIC = 'sem_generic',
    HOME = 'home',
}
